import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchWrapper } from '../_helpers';

// create slice

const name = 'projects';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const projectsActions = { ...slice.actions, ...extraActions };
export const projectsReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        projects: {}
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/user`;

    return {
        getAllById: getAllById()
    };    

    function getAllById() {
        return createAsyncThunk(
            `${name}/getAllById`,
            async ({param}) => await fetchWrapper.get(`${baseUrl}/GetProjects/${param}`)
        );
    }
}

function createExtraReducers() {
    return {
        ...getAllById()
    };

    function getAllById() {
        var { pending, fulfilled, rejected } = extraActions.getAllById;
        return {
            [pending]: (state) => {
                state.projects = { loading: true };
            },
            [fulfilled]: (state, action) => {
                state.projects = action.payload;
            },
            [rejected]: (state, action) => {
                state.projects = { error: action.error };
            }
        };
    }
}
